import { render, staticRenderFns } from "./PagingSync.vue?vue&type=template&id=7a74f1c7&scoped=true"
import script from "./PagingSync.vue?vue&type=script&lang=js"
export * from "./PagingSync.vue?vue&type=script&lang=js"
import style0 from "./PagingSync.vue?vue&type=style&index=0&id=7a74f1c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a74f1c7",
  null
  
)

export default component.exports